import { BaseApiService } from './BaseApiService';
import { sharedTokenRefresh } from './tokenRefresh';
import { debugError } from '../utils/debug';
import type { CalcVersionAvailability } from '../types/calcVersion';

export interface SystemSettings {
    manualSaveEnabled: boolean;
    siteOfflineEnabled: boolean;
    /** BillingDunning: days a past-due team keeps full access before it becomes read-only. */
    billingGraceDays?: number;
    /** Every calc_version_availability row: which state/year combinations users may pick. */
    calcVersions?: CalcVersionAvailability[];
}

/**
 * Service for reading DB-backed, admin-toggleable system settings (e.g. Manual Save).
 * Read-only — the admin write path lives on AdminApiService.saveSystemSetting.
 * See docs/AUTOSAVE_DETAILS.md "Manual Save mode" section.
 */
export class SystemSettingsApiService extends BaseApiService {
    constructor() {
        super(sharedTokenRefresh);
    }

    async getSystemSettings(): Promise<SystemSettings> {
        try {
            const response = await this.postJson('/v1/system-settings/get', {});
            return await this.handleResponse<SystemSettings>(response);
        } catch (error) {
            debugError('Error getting system settings:', error);
            throw error;
        }
    }
}

export const systemSettingsApiService = new SystemSettingsApiService();
